import {makeReactContext} from 'lib/makeReactContext';
import {Method} from 'procedures/ProcedureDomainTypes';

interface MethodSidepanelContextValue {
  saveImmediately: ((methodData: Method) => void) | null;
}

const MethodSidepanelContext = makeReactContext<MethodSidepanelContextValue>(
  () => ({
    // This context will not be available in legacy procedures; callers can check for null to determine
    // whether to use this saveImmediately or the one provided by ProcedurePageContext
    saveImmediately: null,
  }),
  'MethodSidepanelContext'
);

export default MethodSidepanelContext;
